import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { funds, complianceOfficer } from '../data/funds';

const Home = () => {
  const currentYear = new Date().getFullYear();
  const mainContentRef = useRef(null);

  useEffect(() => {
    document.title = 'Zephyr Peacock — Alternative Investment Funds';
    mainContentRef.current?.focus();
  }, []);

  return (
    <div>
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      {/* ── White Site Header with Logo ── */}
      <header className="site-header" role="banner">
        <div className="site-header-inner">
          <img
            src="/img/ZP logo.jpg"
            alt="Zephyr Peacock logo"
            className="site-logo"
          />
          <p className="header-sebi-note">
            SEBI Registered<span>Alternative Investment Funds</span>
          </p>
        </div>
      </header>

      {/* ── Teal Description Banner ── */}
      <section className="desc-banner" aria-labelledby="about-zephyr-heading">
        <div className="desc-banner-inner anim-fade-up">
          <span id="about-zephyr-heading" className="desc-eyebrow">About Us</span>
          <p className="desc-text">
            <strong>Zephyr Peacock (ZP)</strong> provides equity financing for
            fast growing, early to growth stage companies led by strong
            entrepreneurs and management teams.
          </p>
        </div>
      </section>

      {/* ── Funds Section ── */}
      <main
        id="main-content"
        className="funds-section"
        role="main"
        aria-labelledby="funds-heading"
        tabIndex={-1}
        ref={mainContentRef}
      >
        <h1 className="sr-only">Zephyr Peacock — Alternative Investment Funds</h1>
        <p id="funds-disclosure-label" className="section-eyebrow anim-fade-up">Disclosure</p>
        <h2 id="funds-heading" className="section-heading anim-fade-up anim-delay-1">
          Our <span>Investment Funds</span>
        </h2>

        <div
          className="funds-grid"
          role="list"
          aria-labelledby="funds-heading"
          aria-describedby="funds-disclosure-label"
        >
          {funds.map((fund, i) => (
            <Link
              key={fund.id}
              to={fund.path}
              className={`fund-card anim-fade-up anim-delay-${i + 2}`}
              aria-label={`View details for ${fund.name}`}
              role="listitem"
            >
              <span className={`fund-badge ${fund.category === 'Category I' ? 'badge-cat-i' : 'badge-cat-ii'}`}>
                {fund.category}
              </span>

              <h3 className="fund-name">{fund.name}</h3>
              <p className="fund-manager">{fund.investmentManager}</p>

              <div className="fund-divider" aria-hidden="true" />

              <div className="fund-sebi-row">
                <span className="fund-sebi-label">SEBI Registration</span>
                <span className="fund-sebi-num">{fund.sebi}</span>
              </div>
              <div className="fund-sebi-row">
                <span className="fund-sebi-label">Scores ID</span>
                <span className="fund-sebi-num">{fund.scoresId}</span>
              </div>

              <div className="fund-cta" aria-hidden="true">
                View details
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 8h10M9 4l4 4-4 4" />
                </svg>
              </div>
            </Link>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="site-footer" role="contentinfo">
        <p>Compliance Officer — {complianceOfficer}</p>
        <p>© {currentYear} Zephyr Peacock. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;
